import { Row, Col, Image } from 'antd';
import { config } from '../../../config';
import { useTranslation, withTranslation } from 'react-i18next';
import React from 'react';
import { Typography, ResponsiveContainer } from '@sunday/component';
import achievementData from './home-achievement.json';
import styles from './home-achievement.module.scss';

const { ASSET_PREFIX } = config;
const HomePageAchievementNameSpace = ['component.home.achievement'];

const HomeAchievement = () => {
  const { t } = useTranslation(HomePageAchievementNameSpace);

  return (
    <div style={{ display: "flex", alignItems: "center", flexDirection: "column"}}>
      <ResponsiveContainer className={styles.container}>
        <Row justify="center">
          <Col xl={{ span: 24}} xs={0}>
            <Typography.Display designLevel={3} weight='bold' className={styles.title} >
              {t('title')}
            </Typography.Display>
          </Col>
          <Col xl={0} xs={24}>
            <Typography.Headline designLevel={1} weight='bold' className={styles.title} >
              {t('title')}
            </Typography.Headline>
          </Col>

        </Row>
        {achievementData.map((item: any[], index: number) => (
          <Row
            justify="center"
            gutter={[
              {
                xs: 24,
                sm: 40,
                xl: 80,
              },
              24,
            ]}
            className={index === 0 ? styles.logos : styles.logos2}
            key={`achievement-${index + 1}`}
          >
            {item.map((item: any, idx: number) => (
              <Col key={`achievement-${index + 1}-${idx + 1}`} >
                {item.href ? (
                  <a href={item.href} target="_blank" rel="noopener noreferrer">
                    <Image
                      width={268}
                      height={114}
                      preview={false}
                      alt={item.altImg}
                      src={`${ASSET_PREFIX}/static/img/${item.fileName}`}
                    />
                  </a>
                ) : (
                  <Image
                    width={268}
                    height={114}
                    preview={false}
                    alt={item.altImg}
                    src={`${ASSET_PREFIX}/static/img/${item.fileName}`}
                  />
                )}
              </Col>
            ))}
          </Row>
        ))}
      </ResponsiveContainer>
    </div>
  );
};

export default withTranslation('page.home')(HomeAchievement);
